export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://be-compass.dev.theloop.tech/api',
  appVersion: '1.0.0-dev',
  keycloak: {
    url: 'https://keycloak-development.stg.theloop.tech/',
    realm: 'compass',
    clientId: 'fe-compass',
  },
  /** Client-side max size for manually uploaded identity documents (the backend enforces 10MB). */
  identityDocumentMaxSizeMb: 10,
  api: {
    baseUrl: 'https://api-development.stg.theloop.tech',
  },
};
